import { createRoot } from 'react-dom/client';
import { RelatedContentProvider, RelatedContent } from '../../UI/related-content/index'

const RenderCoponent = props => {
    return (
        <RelatedContentProvider {...props}>
            <RelatedContent {...props} />
        </RelatedContentProvider>
    );
}

const renderBlock = () => {
    const relatedContentElements = document.getElementsByClassName('related-content-root');
    for (let element of relatedContentElements) {
        const props = JSON.parse(JSON.stringify(window.__INITIAL_PROPS__[element.id]));
        const root = createRoot(element);
        root.render(<RenderCoponent {...props} />);
    }
};

renderBlock();